import { render, staticRenderFns } from "./SwitchPropertySummary.vue?vue&type=template&id=bae03a82&scoped=true&"
import script from "./SwitchPropertySummary.vue?vue&type=script&lang=js&"
export * from "./SwitchPropertySummary.vue?vue&type=script&lang=js&"
import style0 from "./SwitchPropertySummary.vue?vue&type=style&index=0&id=bae03a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae03a82",
  null
  
)

export default component.exports